import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { editUnavailabilityError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

const initialState: State = [];

function handleRequest(
  state: State,
  { unavailability }: Boundaries["editUnavailability"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          unavailability,
          request: setRequestStateToPending(),
          error: editUnavailabilityError,
        },
      ];
}

function handleSuccess(
  state: State,
  unavailability: Boundaries["editUnavailability"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToSuccess(),
          error: editUnavailabilityError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          unavailability,
          request: setRequestStateToSuccess(),
          error: editUnavailabilityError,
        },
      ];
}

function handleFailure(
  state: State,
  { error, unavailability }: Boundaries["editUnavailability"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure(), error },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          unavailability,
          request: setRequestStateToFailure(),
          error,
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editUnavailabilityRequested]: handleRequest,
    [events.editUnavailabilitySucceeded]: handleSuccess,
    [events.editUnavailabilityFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
